import { MediaOpts } from '../get-s3-url';
import { S3Img, S3ImgProps } from '../s3-img';
import { getUserPath } from './get-path';

export const S3UserImg = function S3UserImg({
  ref,
  userId,
  s3Key,
  ...rest
}: {
  userId: string;
  s3Key?: string;
  ref?: React.Ref<HTMLImageElement>;
} & Omit<S3ImgProps, 'path'> &
  MediaOpts) {
  return (
    <S3Img
      ref={ref}
      path={s3Key ? getUserPath(userId, s3Key) : undefined}
      {...rest}
    />
  );
};
